<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <CoffeeOff /> -->
  </div>
</template>

<script>
// import CoffeeOff from "vue-material-design-icons/CoffeeOff.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiCoffeeOff } from "@mdi/js"

export default {
  name: "CoffeeOffIcon",
  components: {
    SvgIcon
    // CoffeeOff,
  },
  data() {
    return {
      path: mdiCoffeeOff,
    }
  }
}
</script>
